var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "36.684px",
    viewBox: "0 0 55 36.684",
    enableBackground: "new 0 0 55 36.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "10.784,32.547 4.653,32.547 4.653,12.928 6.153,12.928 6.153,31.047 10.784,31.047  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.279,
    y: 31.047,
    fill: "#00A79D",
    width: 20.38,
    height: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "54.332,32.547 48.378,32.547 48.378,31.047 52.832,31.047 52.832,21.654 42.939,5.484  13.898,5.484 13.898,3.984 43.781,3.984 54.332,21.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "50.805,17.693 38.266,17.254 36.424,4.844 37.907,4.624 39.564,15.799 50.855,16.194  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M15.271,36.402c-2.552,0-4.627-2.075-4.627-4.627c0-2.551,2.075-4.627,4.627-4.627 c2.551,0,4.626,2.076,4.626,4.627C19.897,34.326,17.821,36.402,15.271,36.402z M15.271,28.148c-2,0-3.627,1.627-3.627,3.627 s1.627,3.627,3.627,3.627c1.999,0,3.626-1.627,3.626-3.627S17.27,28.148,15.271,28.148z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M15.271,36.652c-2.689,0-4.877-2.188-4.877-4.877c0-2.688,2.188-4.877,4.877-4.877 c2.688,0,4.876,2.188,4.876,4.877C20.147,34.464,17.959,36.652,15.271,36.652z M15.271,28.398c-1.862,0-3.377,1.517-3.377,3.377 c0,1.861,1.515,3.377,3.377,3.377c1.861,0,3.376-1.516,3.376-3.377C18.647,29.914,17.132,28.398,15.271,28.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M43.997,36.434c-2.552,0-4.627-2.076-4.627-4.627s2.075-4.627,4.627-4.627s4.627,2.076,4.627,4.627 S46.549,36.434,43.997,36.434z M43.997,28.18c-2,0-3.627,1.627-3.627,3.627s1.627,3.627,3.627,3.627s3.627-1.627,3.627-3.627 S45.997,28.18,43.997,28.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M43.997,36.684c-2.688,0-4.877-2.188-4.877-4.877c0-2.688,2.188-4.877,4.877-4.877 s4.877,2.188,4.877,4.877C48.874,34.496,46.688,36.684,43.997,36.684z M43.997,28.43c-1.86,0-3.377,1.516-3.377,3.377 s1.517,3.377,3.377,3.377c1.862,0,3.377-1.516,3.377-3.377S45.859,28.43,43.997,28.43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.668,
    y: 3.984,
    fill: "#00A79D",
    width: 9.47,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.653,
    y: 0,
    fill: "#00A79D",
    width: 1.5,
    height: 9.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.4cb13cf9e640967425acd946dbf7273d.svg";
export { ForwardRef as ReactComponent };